import { components } from "@/api-schema";
import { getModelFamilyDatId } from "@/common/helpers/get-model-family-dat-id";
import { DeviceType } from "@/common/hooks/use-device";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { EmptyValue } from "@/components/ui/empty-value";
import i18next from "i18next";
import { commonColumns } from "./_constants/common-columns";

export type ModelFamilyTableType = components["schemas"]["ModelFamily"];

type ModelFamilyBrand = ModelFamilyTableType["brand"];

function renderNamedItem(item: { uuid?: string; name?: string } | undefined) {
  if (!item) {
    return <EmptyValue />;
  }

  return <span className="text-xs">{item.name}</span>;
}

export const modelFamilyTableDefaultColumns = {
  columnName: commonColumns.columnName<ModelFamilyTableType>(),
  columnDatId: commonColumns.columnDatId<ModelFamilyTableType>((modelFamily) =>
    getModelFamilyDatId(modelFamily.modelFamilyIdentifiers),
  ),

  columnBrand: {
    id: "brand",
    size: 160,
    enableSorting: true,
    header: () => i18next.t("common:Brand"),
    visibility: [DeviceType.Desktop, DeviceType.Widescreen],
    accessorFn: (row: ModelFamilyTableType) => row.brand,
    cell: (row) => renderNamedItem(row.getValue() as ModelFamilyBrand),
  } as ImplementedAccessorColumnDef<ModelFamilyTableType, ModelFamilyBrand>,

  columnUuid: commonColumns.columnUuid<ModelFamilyTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<ModelFamilyTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<ModelFamilyTableType>(),
};
